export default {
    language: 'hr-HR',
    navigation: 'Povratak',
    home: {
        title: 'Yacht Paint Calculator',
        subtitle:
            'Saznajte koji je najbolji antifouling za vaš brod i izračunajte koliko vam je boje potrebno za vaš projekt bojenja',
        findProduct: 'Pronađi proizvod',
        calculateVolume: 'Izračunaj količinu'
    },
    find: {
        questions: {
            type: 'Odaberi svoju <strong>vrstu broda</strong>',
            material: 'Odaberi <strong>materijal</strong> od kojeg je tvoj brod napravljen',
            sailFrequency: '<strong>Koliko često</strong> koristiš svoj brod?',
            paintLocation: '<strong>Gdje</strong> bojaš svoj brod?',
            waterType: 'U kakvoj <strong>vrsti vode</strong> koristiš svoj brod?'
        },
        answers: {
            help: 'Trebate pomoć s odabirom antifoulinga?',

            type: [
                {
                    label: 'Jedrilica',
                    icon: 'sailingBoat',
                    value: 'sailing'
                },
                {
                    label: 'Motorni brod (spori)',
                    sublabel: 'do 20 čvorova',
                    icon: 'motorboatSlow',
                    value: 'motor-slow'
                },
                {
                    label: 'Motorni brod (brzi)',
                    sublabel: 'brži od 20 čvorova',
                    icon: 'motorboatFast',
                    value: 'motor-fast'
                }
            ],
            material: [
                {
                    label: 'Staklo-plastika',
                    value: 'plastic'
                },
                {
                    label: 'Željezo',
                    value: 'iron'
                },
                {
                    label: 'Drvo',
                    value: 'wood'
                },
                {
                    label: 'Aluminij',
                    value: 'aluminium'
                }
            ],
            sailFrequency: [
                {
                    label: 'Rijetko',
                    sublabel: '1-2 puta mjesečno ili manje',
                    value: 'low'
                },
                {
                    label: 'Često',
                    sublabel: '1-2 puta tjedno',
                    value: 'medium'
                },
                {
                    label: 'Vrlo često',
                    sublabel: 'Skoro svaki dan',
                    value: 'high'
                }
            ],
            paintLocation: [
                {
                    label: 'Odaberi državu',
                    countries: [
                        { label: 'Velika Britanija', value: 'en-GB' },
                        { label: 'Danska', value: 'da-DK' },
                        { label: 'Španjolska', value: 'es-ES' },
                        { label: 'Finska', value: 'fi-FI' },
                        { label: 'Njemačka', value: 'de-DE' },
                        { label: 'Grčka', value: 'el-GR' },
                        { label: 'Hrvatska', value: 'hr-HR' },
                        { label: 'Norveška', value: 'nb-NO' },
                        { label: 'Nizozemska', value: 'nl-NL' },
                        { label: 'Švedska - Istočna obala', value: 'sv-SE_e' },
                        { label: 'Švedska - Zapadna obala', value: 'sv-SE_w' },
                        { label: 'Švedska - Jezera', value: 'sv-SE_l' }
                    ]
                }
            ],
            waterType: [
                { label: 'More/Ocean', value: 'sea/ocean' },
                { label: 'Rijeka', value: 'rivers' },
                { label: 'Jezero', value: 'lakes' }
            ]
        },
        result: {
            heading: 'Preporučamo',
            selection: {
                title: 'Tvoj odabir',
                type: 'Vrsta broda',
                waterType: 'Vrsta vode',
                material: 'Materijal',
                sailFrequency: 'Aktivnost',
                country: 'Država'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Best buy',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Best buy',
                economicAlternative: 'Biocide-free Economic'
            },
            findOutMore: 'Saznaj više',
            whereToBuy: 'Gdje kupiti',
            email: 'Email',
            send: 'Pošalji',
            feedback: {
                title: 'Je li ti ova infromacija bila korisna?',
                yes: 'Da',
                no: 'Ne',
                comment: 'Komentar',
                placeholder: 'unesi svoj komentar ovdje'
            },
            recommendation: {
                title: 'Pošalji preporuku na email'
            },
            calculateVolume: 'Izračunaj količinu'
        }
    },
    calculate: {
        letsCalculate: 'Izračunaj',
        questions: {
            antifouling: 'Odaberi antifouling',
            keelType: 'Odaberi <strong>vrstu kobilice</strong>',
            dimensions: '<strong>Dimenzije</strong> tvoga broda su'
        },
        answers: {
            keelType: [
                {
                    label: 'Duboka kobilica',
                    icon: 'finKeel',
                    value: 'fin'
                },
                {
                    label: 'Duga kobilica',
                    icon: 'fullKeel',
                    value: 'full'
                }
            ],
            dimensionTitles: [
                {
                    title: 'Individualne dimenzije'
                },
                {
                    title: 'ILI podvodne dimenzije u m2'
                }
            ],
            dimensions: [
                {
                    type: 'unit',
                    label: 'Jedinica',
                    values: [{ label: 'Metri', value: 'm' }, { label: 'Stope', value: 'f' }]
                },
                {
                    type: 'waterline',
                    label: 'Duljina na vodenoj liniji'
                },
                {
                    type: 'beam',
                    label: 'Širina'
                },
                {
                    type: 'draft',
                    label: 'Dubina'
                },
                {
                    type: 'm2',
                    label: 'm2'
                }
            ]
        },
        result: {
            heading: 'Preporučena količina',
            selection: {
                title: 'Tvoj odabir',
                antifouling: 'Antifouling',
                type: 'Vrsta broda',
                material: 'Materijal',
                sailFrequency: 'Aktivnost',
                country: 'Država',
                keelType: 'Vrsta kobilice',
                dimensions: 'Dimenzije broda'
            },
            category: {
                premium: 'Premium',
                alternative: 'Biocide-free Premium',
                bestBuy: 'Best buy',
                economic: 'Economic',
                bestBuyAlternative: 'Biocide-free Best buy',
                economicAlternative: 'Biocide-free Economic'
            },
            suggestedAmount: 'Preporučena količina',
            suggestedAmountTwoCoats: 'Preporučena količina (2 sloja)',
            oneCoat: '(1 sloj)',
            fiveCoats: '(5 slojeva)',
            primerAltTiecoat: 'Ne zaboravite uvijek koristiti Tiecoat!',
            primerAltSilicSeal:
                '<strong>SLUČAJ 2</strong><br/>Nanošenje na stari protuobraštajni premaz koji je u dobrom stanju - jednostavan prelazak na sustav Silic One',
            primerAlLight:
                '<strong>SLUČAJ 1</strong><br/>Uklanjanje starog protuobraštajnog sustava i nanošenje punog sustava & novo plovilo bez epoksija',
            primer:
                '<strong>Brod</strong> je <strong>teško oštećen</strong> ili ga <strong>bojate prvi put?</strong> Vjerojatno ćete trebati i...',
            whereToBuy: 'Gdje kupiti',
            email: 'Email',
            send: 'Pošalji',
            or: 'ILI',
            feedback: {
                title: 'Je li ti ova infromacija bila korisna?',
                yes: 'Da',
                no: 'Ne',
                comment: 'Komentar',
                placeholder: 'Unesi svoj komentar ovdje'
            },
            recommendation: {
                title: 'Pošalji preporuku na email'
            },
            calculateVolume: 'Izračunaj volumen'
        }
    },
    map: {
        country: 'Država',
        city: 'Grad',
        getDirections: 'Upute za vožnju',
        placeholder: 'Svi gradovi...'
    },
    footer: 'Hempel Yacht - sve što trebate znati o bojanju brodova'
}
